/**
 * An invite token parked across a sign-in round trip.
 *
 * Someone following an invite link who has no account yet goes signup → back to
 * the invite. Session storage (not local) so it dies with the tab and cannot
 * leak into an unrelated later visit.
 */
export const PENDING_INVITE_KEY = 'sp.pendingInvite';

export function takePendingInvite(): string | null {
  try {
    const token = sessionStorage.getItem(PENDING_INVITE_KEY);
    if (token) sessionStorage.removeItem(PENDING_INVITE_KEY);
    return token;
  } catch {
    return null;
  }
}

/**
 * Where to send someone once they are signed in.
 *
 * Shared by the auth screen and the app shell so the two cannot disagree — the
 * auth screen navigates immediately on success, which would otherwise race the
 * shell's redirect and strand an invitee on their empty board list.
 */
export function postAuthRoute(): { name: 'invite'; token: string } | { name: 'home' } {
  const pending = takePendingInvite();
  return pending ? { name: 'invite', token: pending } : { name: 'home' };
}
